import React from "react";

const Footer = () => {
  return (
    <>
      <footer class="footer-wrap-layout1">
        <div class="copyright">
          © Copyrights <a href="#">akkhor</a> 2019. All rights reserved.
          Designed by <a href="#">PsdBosS</a>
        </div>
      </footer>
    </>
  );
};

export default Footer;
